export const ctorFromKeyArray = (ks, map) => ks.reduce((c, k) => ({ ...c, [k]: map(k) }), {});
export const objectEntries = (o) => Object.entries(o);
export const objectMap = (o, map) => Object.assign({}, ...objectEntries(o).map(([k, v]) => ({ [k]: map(v, k) })));
export const objectPick = (o, ks) => objectKeyFilter(o, ks, true);
export const objectOmit = (o, ks) => objectKeyFilter(o, ks, false);
const objectKeyFilter = (o, ks, pick) => Object.assign({}, ...objectEntries(o)
    .filter(([k]) => (pick ? ks.includes(k) : !ks.includes(k)))
    .map(tupleToKeyValue));
const tupleToKeyValue = ([k, v]) => ({ [k]: v });
